import styled from "styled-components"

export const Placeholder = styled.div`
	width: 100%;
	height: 100%;

	display: flex;

	background-color: #ECECEC;
`

export const PlaceholderImage = styled.img`
	margin: auto;
`

export const PictureContainer = styled.div`
	width: 100%;
	height: 100%;

	position: relative;
`

export const BlurEffect = styled.div`
	width: 100%;
	height: 100%;

	position: absolute;
	z-index: 300;

	background-color: transparent;
	backdrop-filter: ${({ blur }) => `blur(${blur})`};
`

export const Picture = styled.img`
	width: 100%;
	height: 100%;

	object-fit: cover;
`
